import { sliderTwoActive } from "../../sliderProps";
import { Link } from 'react-router-dom';
import { Component, Fragment } from "react";
import Slider from "react-slick";


import slider1 from "../../assets/images/slider/slider1.jpg"
import slider2 from "../../assets/images/slider/slider2.jpg"
import slider3 from "../../assets/images/slider/slider3.jpg"
import slider4 from "../../assets/images/slider/slider4.jpg"
import slider5 from "../../assets/images/slider/slider5.jpg"


export default class Hero4Slider extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    return (
      <Fragment>
        <Slider
          {...sliderTwoActive}
          ref={(c) => (this.slider = c)}
          className="slider-two-active"
        >
          <div className="slider-item-two">
            <div className="container">
              <div className="slide-content">
                <span className="sub-title">Welcome to SOS</span>
                <h1>Surgical Instruments Sourcing Partner</h1>
                <Link legacyBehavior href="/contact">
                  <a className="theme-btn style-two mt-15">
                    Contact Us <i className="fas fa-long-arrow-right" />
                  </a>
                </Link>
                {/* <a
                  href="https://www.youtube.com/watch?v=9Y7ma241N8k"
                  className="mfp-iframe video-play-text mt-15"
                >
                  <i className="fas fa-play" /> <span>How IT Works</span>
                </a> */}
              </div>
            </div>
            <div
              className="slider-image"
              style={{
                backgroundImage: `url(${slider1})`,
              }}
            />
          </div>
          <div className="slider-item-two">
            <div className="container">
            <div className="slide-content">
                <span className="sub-title">Welcome to SOS</span>
                <h1>Surgical Instruments Sourcing Partner</h1>
                <Link legacyBehavior href="/contact">
                  <a className="theme-btn style-two mt-15">
                    Contact Us <i className="fas fa-long-arrow-right" />
                  </a>
                </Link>
                {/* <a
                  href="https://www.youtube.com/watch?v=9Y7ma241N8k"
                  className="mfp-iframe video-play-text mt-15"
                >
                  <i className="fas fa-play" /> <span>How IT Works</span>
                </a> */}
              </div>
            </div>
            <div
              className="slider-image"
              style={{
                backgroundImage: `url(${slider2})`,
              }}
            />
          </div>
          <div className="slider-item-two">
            <div className="container">
            <div className="slide-content">
                <span className="sub-title">Welcome to SOS</span>
                <h1>Surgical Instruments Sourcing Partner</h1>
                <Link legacyBehavior href="/contact">
                  <a className="theme-btn style-two mt-15">
                    Contact Us <i className="fas fa-long-arrow-right" />
                  </a>
                </Link>
                {/* <a
                  href="https://www.youtube.com/watch?v=9Y7ma241N8k"
                  className="mfp-iframe video-play-text mt-15"
                >
                  <i className="fas fa-play" /> <span>How IT Works</span>
                </a> */}
              </div>
            </div>
            <div
              className="slider-image"
              style={{
                backgroundImage: `url(${slider3})`,
              }}
            />
          </div>
          <div className="slider-item-two">
            <div className="container">
            <div className="slide-content">
                <span className="sub-title">Welcome to SOS</span>
                <h1>Surgical Instruments Sourcing Partner</h1>
                <Link legacyBehavior href="/contact">
                  <a className="theme-btn style-two mt-15">
                    Contact Us <i className="fas fa-long-arrow-right" />
                  </a>
                </Link>
                {/* <a
                  href="https://www.youtube.com/watch?v=9Y7ma241N8k"
                  className="mfp-iframe video-play-text mt-15"
                >
                  <i className="fas fa-play" /> <span>How IT Works</span>
                </a> */}
              </div>
            </div>
            <div
              className="slider-image"
              style={{
                backgroundImage: `url(${slider4})`,
              }}
            />
          </div>
          <div className="slider-item-two">
            <div className="container">
            <div className="slide-content">
                <span className="sub-title">Welcome to SOS</span>
                <h1>Surgical Instruments Sourcing Partner</h1>
                <Link legacyBehavior href="/contact">
                  <a className="theme-btn style-two mt-15">
                    Contact Us <i className="fas fa-long-arrow-right" />
                  </a>
                </Link>
                {/* <a
                  href="https://www.youtube.com/watch?v=9Y7ma241N8k"
                  className="mfp-iframe video-play-text mt-15"
                >
                  <i className="fas fa-play" /> <span>How IT Works</span>
                </a> */}
              </div>
            </div>
            <div
              className="slider-image"
              style={{
                backgroundImage: `url(${slider5})`,
              }}
            />
          </div>
        </Slider>
        <div className="slider-arrows">
          <div className="container rel">
            <button className="prev-slider slick-arrow" onClick={this.previous}>
              <i className="fal fa-angle-left" />
            </button>
            <button className="next-slider slick-arrow" onClick={this.next}>
              <i className="fal fa-angle-right" />
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}
